export { default as loader } from '@monaco-editor/loader';
export { default as DiffEditor } from './DiffEditor/index.js';
export { default as useMonaco } from './hooks/useMonaco/index.js';
export { default } from './Editor/index.js';
